import React from 'react'
import { TypographyProps, Typography } from '../Typography'
import { FieldErrors, FieldError } from 'react-hook-form'
import styled from 'styled-components'

export const FormError = ({
  errors,
  fieldName,
  text,
  variant = '7',
  color = 'danger',
  center,
  ...rest
}: FormErrorProps) => {
  const getError = () => {
    if (!errors || !fieldName) return null

    return (
      (errors[fieldName] as FieldError)?.message || errors[fieldName] || null
    )
  }

  return (
    <ErrorWrapper center={center} className="mt-1">
      <Typography color={color} as="span" variant={variant} {...rest}>
        {text || getError()}
      </Typography>
    </ErrorWrapper>
  )
}

export type FormErrorProps = TypographyProps & {
  errors?: FieldErrors | null
  fieldName?: string
  center?: boolean
  text?: string // overrides error
}

const ErrorWrapper = styled.div.attrs({
  className: 'mt-1',
})<{ center?: boolean }>`
  ${(props) => props.center && 'text-align: center;'}
  font-weight: 300;
`
